import * as React from 'react'
import { inject, observer } from 'mobx-react'
import LoginForm from '../../PartialViews/Account/LoginForm'
import UserStore from '../../../Stores/UserStore'
// import { history } from '../../Routing'

export interface ILoginPageProps {
    userStore?: UserStore
}

@inject('userStore')
@observer
export default class LoginPage extends React.Component<ILoginPageProps> {

    // constructor(props: ILoginPageProps) {
    //     super(props)

    //     if (this.props.userStore!.checkSession) {
    //         history.push('/')
    //     }
    // }

    render() {
        return (
            <div className="loginPage">
                <LoginForm />
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Account/LoginPage.tsx